
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import {  ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';
import { GlossType } from '../../models/tables/accreditation/gloss-type';

@Injectable()
export class GlossTypeEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    glossType: GlossType;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise((resolve, reject) => {
            Promise.all([this.getGlossType()]).then(
                (res) => {
                    resolve(res);
                },
                reject
            );
        });
    }

    getGlossType(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.glossType = data;
                this.onDataChanged.next(this.glossType);
                resolve(this.glossType);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('glossType/' + this.routeParams.id)
                .subscribe({
                    next:(res: GlossType ) => {
                        this.glossType = res;
                        this.onDataChanged.next(this.glossType);
                        resolve(res);
                    },error: (err: any) => { reject(err); }
                });
            }
        });
    }

    insert(glossType): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('glossType/', glossType)
                .subscribe({
                    next:(response: HttpResponse<any>) => {
                        resolve(response);
                        this.snackBar.successMessage(response.body.message);
                    },error: (err: any) => { reject(err)}
                });
            });
    }

    edit(glossType): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('glossType/', glossType)
                .subscribe({
                    next:(response: HttpResponse<any>) => {
                        resolve(response);
                        this.snackBar.successMessage(response.body.message);
                    },error: (err: any) => { reject(err)}
                });
            });
    }

    delete(glossType): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('glossType/' + glossType.id)
                .subscribe({
                    next:(response: HttpResponse<any>) => {
                        resolve(response);
                        this.snackBar.successMessage(response.body.message);
                    },error: (err: any) => { reject(err)}
                });
            });
    }

    checkLastModifications(): GlossType {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
